import { cn } from "../../utils/class-names";
import type { IconProps } from "../types";

export function RabbyIcon({ className }: IconProps): JSX.Element {
  return (
    <svg
      className={cn("h-6 w-6", className)}
      fill="none"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.9645 17.895C32.1561 15.233 26.2653 7.79598 20.6376 4.69757C17.0902 2.29726 13.3939 2.62703 12.6453 3.68094C11.0024 5.99386 18.0855 7.9537 22.8225 10.2407C21.8042 10.683 20.8446 11.4766 20.2804 12.4916C18.5143 10.5636 14.6382 8.90331 10.09 10.2407C7.02501 11.1419 4.47779 13.2666 3.49331 16.4758C3.25409 16.3695 2.98924 16.3104 2.71059 16.3104C1.64505 16.3104 0.78125 17.1742 0.78125 18.2397C0.78125 19.3053 1.64505 20.1691 2.71059 20.1691C2.9081 20.1691 3.52564 20.0366 3.52564 20.0366L13.3939 20.1081C9.44738 26.3689 6.3285 27.2841 6.3285 28.3688C6.3285 29.4534 9.31271 29.1595 10.4332 28.7552C15.7972 26.8198 21.5584 20.7878 22.547 19.0514C26.6986 19.5694 30.1876 19.6306 30.9645 17.895Z"
        fill="url(#paint0_linear_413_2399)"
      />
      <path
        clipRule="evenodd"
        d="M22.8934 10.237C23.0884 10.1378 23.0533 9.82721 22.9951 9.58145C22.8565 8.99612 20.4656 6.63512 18.2203 5.57762C15.2322 4.17024 13.0135 4.20829 12.6016 4.8296C13.1737 6.12525 16.0981 7.33909 19.1541 8.60756C20.4316 9.13782 21.7322 9.67763 22.8934 10.237Z"
        fill="url(#paint1_linear_413_2399)"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M18.9458 23.082C18.3366 22.8512 17.6502 22.6392 16.872 22.4464C17.7192 20.9304 17.897 18.6861 17.0969 17.2671C15.9739 15.2758 14.5643 14.2158 11.2887 14.2158C9.48707 14.2158 4.63636 14.8227 4.55024 18.8719C4.54124 19.2954 4.54996 19.6836 4.58047 20.0407L13.3885 20.1046C12.197 21.9947 11.081 23.3976 10.1035 24.4651C11.2986 24.7712 12.2816 25.0274 13.1831 25.2625C14.014 25.4791 14.7757 25.6776 15.5705 25.8806C16.7931 24.9891 17.9422 24.0173 18.9458 23.082Z"
        fill="url(#paint2_linear_413_2399)"
        fillRule="evenodd"
      />
      <path
        d="M3.40282 19.634C3.76467 22.71 5.51285 23.9155 9.08507 24.2723C12.6573 24.629 14.7064 24.3897 17.4344 24.6379C19.7128 24.8452 21.7472 26.0063 22.5019 25.605C23.1811 25.2439 22.8011 23.9393 21.8923 23.1024C20.7142 22.0174 19.0837 21.2631 16.2147 20.9954C16.7865 19.4299 16.6263 17.235 15.7383 16.0408C14.4544 14.3141 12.0845 13.5334 9.08508 13.8745C5.95139 14.2309 2.9487 15.7737 3.40282 19.634Z"
        fill="url(#paint3_linear_413_2399)"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_413_2399"
          x1="9.73309"
          x2="30.7079"
          y1="15.5377"
          y2="21.4858"
        >
          <stop stopColor="#8797FF" />
          <stop offset="1" stopColor="#AAA8FF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_413_2399"
          x1="27.214"
          x2="12.1055"
          y1="15.1262"
          y2="-0.00692304"
        >
          <stop stopColor="#3B22A0" />
          <stop offset="1" stopColor="#5156D8" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint2_linear_413_2399"
          x1="19.3657"
          x2="4.85354"
          y1="23.6167"
          y2="15.288"
        >
          <stop stopColor="#3B1E8F" />
          <stop offset="1" stopColor="#6A6FFB" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint3_linear_413_2399"
          x1="11.013"
          x2="20.8397"
          y1="15.3874"
          y2="27.8732"
        >
          <stop stopColor="#8898FF" />
          <stop offset="0.983895" stopColor="#5F47F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
